import { Charge, LookupValue } from "@/services/model";

import { log } from "./log.ts";

/**
 * Some shared `common.buttons.*` values are stored lowercase (reused as
 * running text elsewhere) but must render capitalized as a button label -
 * `text-transform`/`::first-letter` can't reach the text reliably through
 * `Button`'s nested `.btn-label` span, so this capitalizes at the string level.
 */
export const capitalizeFirstLetter = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);

export type availableCurrencies = "CHF";
export const getCurrencyFromLookupValue = (
  currency: LookupValue | undefined,
): availableCurrencies => {
  switch (currency?.id) {
    case 1:
      return "CHF";
    default:
      log(`Could not getCurrencyFromLookupValue: ${JSON.stringify(currency)}`);

      return "CHF";
  }
};

export const getChargeString = (charge: Charge | undefined) => {
  if (charge?.amount != null) {
    return getCurrency(
      charge.amount,
      getCurrencyFromLookupValue(charge.currency),
    );
  }
};

export const getCurrency = (val: number, currency: string) => {
  return new Intl.NumberFormat("de-CH", { style: "currency", currency })
    .format(val)
    .toString();
};

export const getDateString = (date: Date) => {
  return date.toLocaleDateString("de-CH", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

/** `27.07.26` — the two-digit-year form the bills list uses. */
export const getShortDateString = (date: Date) => {
  return date.toLocaleDateString("de-CH", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  });
};
